import { FC } from "react";
import { useRecoilValue } from "recoil";
import { MeterScaleControl as LeafletMeterScaleControl } from "../../../plugins/leaflet/MeterScaleControl";
import { floorPpmState } from "../../../stores";

export const MeterScaleControl: FC = () => {
    const ppm = useRecoilValue(floorPpmState);
    return <LeafletMeterScaleControl ppm={ppm} />;
};
